import React, { useContext, useCallback } from 'react';

import { CanadianOptIn as CanadianOptInComponent } from '../../../../components/ui/Inputs/CanadianOptIn';
import { useEvent } from '../../../../utils/analytics/useEvent';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function CanadianOptIn() {
  const trackEvent = useEvent();
  const { bindCanadianOptIn, isLoading, isCanadian } = useContext(MlifeAccountSetupContext);

  const onContactUsClick = useCallback(() => {
    trackEvent('identity – mlife registration - external link click', 'MGM Resorts Properties', 'mliferegclicks');
  }, [trackEvent]);

  if (!isCanadian) return null;

  return <CanadianOptInComponent onContactUsClick={onContactUsClick} disabled={isLoading} {...bindCanadianOptIn} />;
}

CanadianOptIn.displayName = 'CanadianOptInField';
